// extracted by mini-css-extract-plugin
export default {"vacancy":"vacancy-module___vacancy___b82b905c","header":"vacancy-module___header___c71cbba7"};